import { AlertFilled, SaveOutlined } from '@ant-design/icons'
import { Modal, Table, Radio, Input, Button, Typography } from 'antd'
import React, { useState } from 'react'
import { requestSuccess } from 'utils/requestHandler'
import { getItem } from 'utils/tokenStore'
import { translateAlertDetails } from 'utils/alertDetails'
import { formatDateTime } from 'utils/dateFormat'
import { useTranslation } from 'react-i18next'

const { Text } = Typography

const AlertsModal = (props) => {
  const { t } = useTranslation()
  const [editValues, setEditValues] = useState({})
  const isAdmin = getItem('TYPE') === '1' || getItem('TYPE') === '2'

  const saveComment = (alert) => {
    const value = editValues[alert.ID] !== undefined ? editValues[alert.ID] : (alert.COMMENT || '')
    const newAlerts = props.alerts.map((a) =>
      a.ID === alert.ID ? { ...a, COMMENT: value, COMMENT_BY_NAME: getItem('Username') } : a
    )
    props.onChangeHOC('alerts', newAlerts)
    props.setAlertAccuracyComment(alert.ID, value)
    requestSuccess(t('alert.alertsModal.comment_saved'))
  }

  const columns = [
    {
      key: 'ID',
      title: t('alert.table.id'),
      dataIndex: 'ID',
      sorter: true,
    },
    {
      key: 'URGENCY',
      title: t('alert.table.urgency'),
      render: (_, alert) => (
        alert.URGENCY === 0 ? <span style={{ color: 'green' }}>{t('alert.urgency_levels.information')}</span> :
        alert.URGENCY === 1 ? <span style={{ color: 'yellow' }}>{t('alert.urgency_levels.attention')}</span> :
        alert.URGENCY === 2 ? <span style={{ color: 'orange' }}>{t('alert.urgency_levels.escalated')}</span> :
        <span style={{ color: 'red' }}>{t('alert.urgency_levels.urgent')}</span>
      ),
    },
    {
      key: 'DETAILS',
      title: t('alert.table.details'),
      render: (_, alert) => translateAlertDetails(alert.DETAILS, t),
    },
    {
      key: 'TIMESTAMP',
      title: t('alert.table.date'),
      render: (_, alert) => (
        <span>
          {formatDateTime(alert.TIMESTAMP)}
        </span>
      ),
    },
    {
      key: 'ACCURACY',
      title: t('alert.table.accuracy'),
      render: (_, alert) => (
        <Radio.Group
          onChange={(val) => {
            props.setAlertAccuracy(alert.ID, val.target.value)
            if (alert.DETAILS === 'FALL' && val.target.value === 0) {
              requestSuccess(t('alert.alertsModal.false_alarm_comment'))
            }
          }}
          value={alert.ACCURACY}
        >
          <Radio value={1}>{t('True')}</Radio>
          <Radio value={0}>{t('False')}</Radio>
        </Radio.Group>
      ),
    },
    {
      key: 'COMMENT',
      title: t('alert.table.comment'),
      render: (_, alert) => (
        <div>
          {isAdmin ? (
            <Input.Group compact style={{ display: 'flex', width: 320 }}>
              <Input
                defaultValue={alert.COMMENT || ''}
                placeholder={t('alert.alertsModal.enter_comment')}
                onChange={(e) => setEditValues({ ...editValues, [alert.ID]: e.target.value })}
                onPressEnter={() => saveComment(alert)}
              />
              <Button icon={<SaveOutlined />} onClick={() => saveComment(alert)} />
            </Input.Group>
          ) : (
            alert.COMMENT || ''
          )}
          {alert.COMMENT_BY_NAME && (
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {t('alert.table.commented_by', { name: alert.COMMENT_BY_NAME })}
              </Text>
            </div>
          )}
        </div>
      ),
    }
  ]

  return (
    <Modal
      width={'auto'}
      title={
        <div style={{ textAlign: 'center' }}>
          <AlertFilled style={{ color: 'red' }} /> {t('alert.alert')}
        </div>
      }
      open={true}
      onOk={() => {
        props.action()
        props.close()
      }}
      onCancel={props.close}
    >
      <Table dataSource={props.alerts} columns={columns} />
    </Modal>
  )
}

export default AlertsModal
